import { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import useEventListener from "@use-it/event-listener";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { ButtonOnlyTitle } from "../../../components/Buttons/ButtonOnlyTitle/Index";
import { LoginInput } from "../../../components/InputLogin";
import "./styles.css";
import axios from "../../../services/axios";
import Constants from "../../../constants/Index";
import { useAuth } from "../../../hooks/useAuth";

const newPasswordSchema = Yup.object().shape({
  password: Yup.string()
    .required("Please Enter your password")
    .matches(
      /[0-9]{6,}/,
      "A senha deverá ser composta por no mínimo 6 caracteres, somente números.",
    ),
  confirmpassword: Yup.string()
    .required("Repita sua senha")
    .oneOf([Yup.ref("password"), null], "*Senhas não conferem."),
});

export type NewPasswordFormValues = {
  password: string;
  confirmpassword: string;
};

export function NewPassword() {
  const navigate = useNavigate();
  const { user } = useAuth();

  const {
    control,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm<NewPasswordFormValues>({
    resolver: yupResolver(newPasswordSchema),
    mode: "onChange",
    defaultValues: {
      password: "",
      confirmpassword: "",
    },
  });

  const [newPassword, setNewPassword] = useState(true);

  const onSubmit = async (formData: NewPasswordFormValues) => {
    try {
      await axios.put("/auth/reset", { password: formData.password });
      setNewPassword(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEventListener("keyup", (event: KeyboardEvent) => {
    const { key } = event;
    if (key === "Enter") handleSubmit(onSubmit)();
  });

  return (
    <>
      {newPassword ? (
        <div className="newPassword__container">
          <h1 className="newPassword__container--title">Nova senha</h1>

          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="login__form--input">
              <LoginInput
                variant="password"
                control={control}
                label="Senha"
                id="password"
                error={errors.password}
                maxLength={32}
              />
            </div>

            <div className="login__form--input">
              <LoginInput
                variant="password"
                control={control}
                label="Confirmar Senha"
                id="confirmpassword"
                error={errors.confirmpassword}
                passwordField="confirmpassword"
                maxLength={32}
              />
            </div>

            <div className="d-flex button_container">
              <div className="button_voltar">
                <ButtonOnlyTitle
                  onClick={() => navigate("/entrar")}
                  title="Voltar"
                  theme="light"
                  type="button"
                  id="bt_voltar"
                />
              </div>

              <div className="button_continuar">
                <ButtonOnlyTitle
                  type="submit"
                  title="Continuar"
                  theme="success"
                  disabled={!isValid}
                  id="bt_continuar"
                />
              </div>
            </div>
          </form>
        </div>
      ) : (
        <div className="newPassword__container">
          <h1 className="newPassword__container--title">Senha alterada com sucesso!</h1>
          <h4 className="newPassword__container--subtitle">Agora vamos juntos realizar seu cadastro!</h4>

          <div className="button_começar">
            <ButtonOnlyTitle
              onClick={() => {
                axios.get("/farms/user").then(({ data }) => {
                  if (data.length == 0 && user.role == "MASTER") navigate(Constants.ONBOARDINGV2);
                  else navigate(Constants.PADDOCKS_MAP);
                });
              }}
              title="Começar"
              theme="success"
              id="bt_comecar"
            />
          </div>
        </div>
      )}
    </>
  );
}
